import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'projects',
    loadChildren: () => import('./projects/projects.module').then((m) => m.ProjectsModule),
  },
  {
    path: 'produce',
    loadChildren: () => import('./projects/projects.module').then((m) => m.ProjectsModule),
  },
  {
    path: 'plan',
    loadChildren: () => import('./projects/projects.module').then((m) => m.ProjectsModule),
  },
  {
    path: 'my',
    loadChildren: () => import('./my/my.module').then((m) => m.MyModule),
  },
  {
    path: 'team',
    loadChildren: () => import('./team/team.module').then((m) => m.TeamModule),
  },
  {
    path: 'content',
    loadChildren: () => import('./content/content.module').then((m) => m.ContentModule),
  },
  {
    path: 'sows',
    loadChildren: () => import('./sow/sow.module').then((m) => m.SowModule),
  },
  {
    path: 'campaigns',
    loadChildren: () => import('./campaigns/campaign.module').then((m) => m.CampaginModule),
  },
  {
    path: 'orgs',
    loadChildren: () => import('./organizations/org.module').then((m) => m.OrgModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'messages',
    loadChildren: () => import('./messages/messages.module').then((m) => m.MessagesModule),
  },
  {
    path: 'search',
    loadChildren: () => import('./search/search.module').then((m) => m.SearchModule),
  },
  // Fallback Routes
  {
    path: 'editorial',
    redirectTo: 'produce',
  },
  {
    path: 'designs',
    redirectTo: 'produce',
  },
  {
    path: 'social',
    redirectTo: 'produce',
  },
  {
    path: 'consulting',
    redirectTo: 'produce',
  },
  {
    path: 'tech',
    redirectTo: 'produce',
  },
  {
    path: 'videos',
    redirectTo: 'produce',
  },
  {
    path: 'account-manager',
    redirectTo: 'produce',
  },
  {
    path: 'contracts/contract-details',
    redirectTo: 'sows',
  },
  {
    path: 'contracts',
    redirectTo: 'sows',
  },
  {
    path: 'test',
    loadChildren: () => import('./test/test.module').then((m) => m.TestModule),
  },
  {
    path: 'text',
    loadChildren: () => import('./text-set/text-set.module').then((m) => m.TextSetModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
